import { Col, Row } from 'react-bootstrap';

import PageHeader from '../components/PageHeader';
import Fullwidth from '../components/Layout/Fullwidth';

function Partner() {
    const yearsOfExperience = (new Date().getFullYear()) - 1880;

  return (
    <div>
    <PageHeader title="Reparatur und Wartung aller Nutzfahrzeuge " subtitle="auch Anhänger, Auflieger und Aufbauten " />
    <Row className='page-main '>
           <Fullwidth>
           <Row className="text-center">
                <Col >
                  <img className="partner-image" src='/meiller-logo.png' />
                </Col>
                <Col>
                  <img className="partner-image" src='/mbbpalfinger.jpg' />
                </Col>
                <Col>
                  <img className="partner-image" src='/tollcollect.png' />
                </Col>
                <Col>
                  <img className="partner-image" src='/kienzle.jpg' />
                </Col>
               </Row>

               <Row className="text-center">
                <Col >
                  <img className="partner-image" src='/dekra.png' />
                </Col>
                <Col>
                  <img className="partner-image" src='/knorr.png' />
                </Col>
                <Col>
                  <img className="partner-image" src='/wabco.jpg.gif' />
                </Col>
                <Col>
                  <img className="partner-image" src='/tuv.png' />
                </Col>
               </Row>

               <Row className="text-center">
                <Col >
                  <img className="partner-image" src='/man_logo.svg' />
                </Col>
                <Col>
                  <img className="partner-image" src='/kuepper-weisser.png' />
                </Col>
                <Col>
                  <img className="partner-image" src='/koegel.png' />
                </Col>
               </Row>
           </Fullwidth>
        </Row>
</div>
  );
}

export default Partner;